<script>
    import { getContext, onMount, onDestroy } from "svelte";
    import { Marker } from "@beyonk/svelte-mapbox";
    import { contextKey } from "@beyonk/svelte-mapbox";
    const { getMap, getMapbox } = getContext(contextKey);
    const map = getMap();
    const mapbox = getMapbox();

    // Mobile detection
    import UA from "ua-parser-js";
    const ua = new UA();
    let isMobile = ua.getResult().device["type"] == "mobile";

    export let goto; // [lng, lat] for when clicked
    export let location; // [lng, lat] marker position
    // export let lng; // lng marker position
    // export let lat; // lat marker position
    export let text; // text to display on button
    export let iconPosition = 'right'; // position of icon relative to button (up, down, left, right)
    export let iconRotation; // rotation of icon (0-360 degrees)
    export let rotation = 0; // rotation of marker (0-360 degrees)
    export let zoom = 16.75; // zoom level for when clicked
    export let primaryArrowColor = '#ffffff'; // color of marker body
    export let secondaryArrowColor = '#FFD200';  // color of marker arrow
    export let enabled = true;
    export let mobile; // mobile overrides
    let element; // <Marker> bind element
        
    // Apply mobile overrides
    $: if (isMobile && mobile && typeof mobile === 'object') {
        if (mobile.location) location = mobile.location;
        if (mobile.goto) goto = mobile.goto;
        if (mobile.text) text = mobile.text;
        if (mobile.iconPosition) iconPosition = mobile.iconPosition;
        if (mobile.iconRotation !== undefined) iconRotation = mobile.iconRotation;
        if (mobile.rotation !== undefined) rotation = mobile.rotation;
        if (mobile.zoom) zoom = mobile.zoom;
        if (mobile.primaryArrowColor) primaryArrowColor = mobile.primaryArrowColor;
        if (mobile.secondaryArrowColor) secondaryArrowColor = mobile.secondaryArrowColor;
        if (mobile.enabled !== undefined) enabled = mobile.enabled;
    }

    $: lng = location[0];
    $: lat = location[1];

    const svgHeight = 25;
    const svgWidth = svgHeight * 1.15;

    function goToCampus() {
        map.flyTo({ center: goto, zoom: zoom });
        console.log("clicked");
    }

    $: if(enabled == true){
        if(element){ element.getMarker().addTo(map) }
    }
    $: if(enabled == false){
        if(element){ element.getMarker().remove() }
    }
</script>

<Marker {lat} {lng} popup={false}  bind:this={element}>
    <div class="campus-marker" style="transform: rotate({rotation}deg);">
        <svg
            class="campus-marker--svg {iconPosition}"
            style={iconRotation ? `transform: translateX(-50%) rotate(${iconRotation}deg);` : ""}
            height={svgHeight}
            width={svgWidth}
            
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 115 100"
            xml:space="preserve"
        >
            <defs id="defs16" /><g id="g6" transform="translate(-2.3,-10)"
                ><path
                    d="M 70.2,56.9 34.2,11.6 C 33.3,10.7 31.7,10 30.5,10 H 5.4 c -1.9,0 -3.1,1.2 -3.1,3.1 v 93.4 c 0,1.9 1.2,3.1 3.1,3.1 l 24.5,0.3 c 1.6,0 3.1,-0.6 4,-1.9 L 70.2,62.7 c 1.3,-1.8 1.3,-4.3 0,-5.8 z"
                    id="path2"
                    style="fill:{primaryArrowColor};fill-opacity:1"
                /><path
                    d="M 116.8,56.9 80.5,11.9 C 78.9,10 76.2,9.4 74,11.3 l -7.1,5.9 c -2.2,1.6 -2.5,4.7 -0.6,6.5 L 95.7,60 66.2,96.6 c -1.6,1.9 -1.2,5 0.6,6.5 L 74,109 c 2.2,1.6 4.7,1.2 6.5,-0.6 l 36.3,-45.3 c 1.2,-2.5 1.2,-4.7 0,-6.2 z"
                    id="path4"
                    style="fill:{secondaryArrowColor};fill-opacity:1"
                /></g>
        </svg>
        <div class="campus-marker--button" on:click={goToCampus}>
            <div class="campus-marker--text">{text}</div>
        </div>
    </div>
</Marker>

<style>
    .campus-marker {
        position: relative;
        text-align: center;
    }

    .campus-marker--button {
        padding: 0.5em;
        border: 2px solid #fff;
        border-radius: 10px;
        cursor: pointer;
    }

    .campus-marker:hover .campus-marker--button {
        background: #fff;
    }

    .campus-marker--text,
    .campus-marker--svg {
        display: inline-block;
        vertical-align: middle;
    }

    .campus-marker--text {
        color: white;
        font-size: 18px;
        font-weight: 600;
        margin-right: 0.25em;
        font-family: "Nunito Sans", sans-serif;
        text-shadow: 0 0 10px rgb(255 255 255 / 35%);
        line-height: 1.5;
        text-align: center;
    }
    

    .campus-marker:hover .campus-marker--text {
        color: #000;
    }

    .campus-marker--svg {
        position: absolute;
    }

    .campus-marker--svg.up{
        top: -35px;
        left: 50%;
        transform: translateX(-50%) rotate(-90deg);
        
    }

    .campus-marker--svg.down{
        bottom: -35px;
        left: 50%;
        transform: translateX(-50%) rotate(90deg);
    }

    .campus-marker--svg.left{
        transform: rotate(-180deg);
    }

    .campus-marker--svg.right{
    }

    /* .campus-marker:hover .campus-marker--svg #path3 {
    fill: #000 !important;
    } */

    .campus-marker:hover .campus-marker--svg #path4 {
        /* fill: #000 !important; */
    }
</style>
